import './Home.css';
import { PersonStanding, Blocks, Sprout, Sparkle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function Home() {

  const navigate = useNavigate();

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-img">
          <img src="/assets/hero_img.png" alt="Hero Image" />
        </div>
        <div className="container">
          <div className="hero-content">
            <h1>Technology with a purpose</h1>
            <p className="hero-subtitle">
              SmallRobot: Creating software to build communities and businesses.
            </p>
            <div className="hero-actions">
              <button className="cta-primary" onClick={() => navigate('/vendors')}>Partner with us</button>
              <button className="cta-secondary" onClick={() => navigate('/apps')}>Get TAP</button>
            </div>
          </div>
          <div className="hero-visual">
            <div className="app-preview">
              <div className="preview-card meet">
                <PersonStanding />
                <p>Meet new people.</p>
              </div>
            </div>
            <div className="app-preview">
              <div className="preview-card build">
                <Blocks />
                <p>Build a community.</p>
              </div>
            </div>
            <div className="app-preview">
              <div className="preview-card grow">
                <Sprout />
                <p>Grow your business.</p>
              </div>
            </div>
            <div className="app-preview">
              <div className="preview-card make">
                <Sparkle />
                <p>Make a difference.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="trusted-by">

      </section>

      <section className="tap-for">
        <div className="description">
          <div className="content">
            <div className="header">
              <h2>Built for people and businesses</h2>
              <p>TAP is a community-building platform that helps you meet new people through casual, no-pressure hangouts at public places. Create or join TAPs for brief, friendly conversations while you're already out doing what you love.</p>
              <div className="questions">
                <p>Questions?</p>
                <div className="input-container">
                  <input autoComplete="email" id="email" name="email" type="email" placeholder="email" />
                  <button className="cta-primary">Get answers</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cards">
          <div className="you" onClick={() => navigate('/apps')}>
            <div className="content">
              <div className="content-img">
                <img src="/assets/tap_for_you.png" alt="TAP for You" />
              </div>
              <div className="content-text">
                <div className="header">
                  <h3>For You</h3>
                  <div className="divider"></div>
                </div>
                <p>Meet new people, make friends, and build your network in a casual, no-pressure way.</p>
              </div>
            </div>
          </div>
          <div className="business" onClick={() => navigate('/vendors')}>
            <div className="content">
              <div className="content-img">
                <img src="/assets/tap_for_business.png" alt="TAP for Business" />
              </div>
              <div className="content-text">
                <div className="header">
                  <h3>For Business</h3>
                  <div className="divider"></div>
                </div>
                <p>Create TAP Deals and track foot traffic through our vendor portal.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="community-impact">
        <div className="container">
          <div className="header">
            <h2>It's a <span>real</span> problem</h2>
          </div>
          <div className="tweets-grid">
            <div className="tweet-column column-1">
              <div className="tweet">
                <div className="tweet-header">
                  <div className="avatar">😔</div>
                  <div className="user-info">
                    <span className="name">Sarah M.</span>
                    <span className="handle">@sarah_m</span>
                  </div>
                </div>
                <p>It's so hard to make friends as an adult. Everyone seems so busy with their own lives...</p>
              </div>
              <div className="tweet">
                <div className="tweet-header">
                  <div className="avatar">😞</div>
                  <div className="user-info">
                    <span className="name">Mike Chen</span>
                    <span className="handle">@mikechen</span>
                  </div>
                </div>
                <p>Moved to a new city 6 months ago and still haven't made a single friend. How do people do this?</p>
              </div>
              <div className="tweet">
                <div className="tweet-header">
                  <div className="avatar">😕</div>
                  <div className="user-info">
                    <span className="name">Alex Rivera</span>
                    <span className="handle">@alex_r</span>
                  </div>
                </div>
                <p>Sometimes I go to coffee shops just to be around people, but I never know how to start a conversation.</p>
              </div>
            </div>
            
            <div className="tweet-column column-2">
              <div className="tweet">
                <div className="tweet-header">
                  <div className="avatar">😓</div>
                  <div className="user-info">
                    <span className="name">Jessica K.</span>
                    <span className="handle">@jess_k</span>
                  </div>
                </div>
                <p>The world feels so lonely sometimes. Everyone's glued to their phones, no one talks anymore.</p>
              </div>
              <div className="tweet">
                <div className="tweet-header">
                  <div className="avatar">😐</div>
                  <div className="user-info">
                    <span className="name">David Park</span>
                    <span className="handle">@dpark</span>
                  </div>
                </div>
                <p>Wish there was an easier way to meet like-minded people in my neighborhood without it being weird.</p>
              </div>
              <div className="tweet">
                <div className="tweet-header">
                  <div className="avatar">🤷‍♀️</div>
                  <div className="user-info">
                    <span className="name">Emma Wilson</span>
                    <span className="handle">@emma_w</span>
                  </div>
                </div>
                <p>All my friends moved away after college. Making new ones feels impossible now that I'm working full-time.</p>
              </div>
            </div>
            
            <div className="tweet-column column-3">
              <div className="tweet">
                <div className="tweet-header">
                  <div className="avatar">😥</div>
                  <div className="user-info">
                    <span className="name">Ryan Taylor</span>
                    <span className="handle">@rtaylor</span>
                  </div>
                </div>
                <p>Dating apps for friends exist, but they feel so forced. I just want natural connections.</p>
              </div>
              <div className="tweet">
                <div className="tweet-header">
                  <div className="avatar">😪</div>
                  <div className="user-info">
                    <span className="name">Lisa Chen</span>
                    <span className="handle">@lisa_c</span>
                  </div>
                </div>
                <p>Been working remote for 2 years. My social skills are basically non-existent now.</p>
              </div>
              <div className="tweet">
                <div className="tweet-header">
                  <div className="avatar">😌</div>
                  <div className="user-info">
                    <span className="name">Jordan Smith</span>
                    <span className="handle">@jordan_s</span>
                  </div>
                </div>
                <p>Remember when making friends was as simple as asking someone to play at recess? Those were the days...</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mission-statement">
        <div className="container">
          <div className="mission-content">
            <h2>Unlock even more possibilities with Small Robot</h2>
            <p className="mission-text">
              Building communities, one casual conversation at a time. We're creating spaces 
              where genuine human interactions can flourish without pressure or expectations.
            </p>
          </div>
        </div>
      </section>

      <section className="cta-final">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to build your community?</h2>
            <p>Start connecting with your neighbors today</p>
            <div className="cta-actions">
              <button className="cta-primary" onClick={() => navigate('/vendors')}>Partner with us</button>
              <button className="cta-secondary" onClick={() => navigate('/apps')}>Get TAP</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;